export const ANALYZE = 'ANALYZE';
export const FORECAST = 'FORECAST';
export const TABS = {
  FORECAST,
  ANALYZE
};
export const ANALYZE_ROUTE = '/analyze';
export const CREATE_FORECAST_ROUTE = '/create-forecast';